import { initializeApp } from "firebase/app";

// SECURITY: Firebase config from environment variables only - no hardcoded fallbacks
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// Validate required config before initializing
const requiredKeys = ['apiKey', 'authDomain', 'projectId'] as const;
for (const key of requiredKeys) {
    if (!firebaseConfig[key]) {
        console.error(`Missing required Firebase config: REACT_APP_FIREBASE_${key.toUpperCase().replace(/([A-Z])/g, '_$1').toUpperCase()}`);
    }
}

const app = initializeApp(firebaseConfig);

export default app;